import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// "2019 Range Rover Range Rover Velar" → "2019 Range Rover Velar"
// (vPIC models already carry the make, e.g. under the Range Rover alias)
export function vehicleLabel(year, make, model) {
  const m = model || "";
  const mk = make || "";
  const short = mk && m.toLowerCase().startsWith(mk.toLowerCase() + " ")
    ? m.slice(mk.length).trimStart()
    : m;
  return [year, mk, short].filter(Boolean).join(" ");
}
